import { Order } from 'types/schema-generated-types';

const getOrderNumber = (order: Order): string => {
  if (order.orderNumber && order.itemFulfillmentNumber) {
    return `${order.orderNumber}-${order.itemFulfillmentNumber}`;
  } else if (order.orderNumber) {
    return order.orderNumber;
  }

  return order.ecmsOrderNumber ?? '';
};

export default getOrderNumber;
